/* global attachEvent */

// **************************************************
// 1.0 - Gallery
// **************************************************

const galleryModalElements = document.querySelectorAll('[data-slider="gallery-popup-slider"]');

const galleryModalOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.arrow-left',
    prevEl: '.arrow-right',
  },
};

galleryModalElements.forEach((el) => {
  const galleryPopup = el.closest('.gallery-popup');
  const arrowRight = galleryPopup.querySelector('.arrow-right');
  const arrowLeft = galleryPopup.querySelector('.arrow-left');

  galleryModalOptions.navigation.nextEl = arrowRight;
  galleryModalOptions.navigation.prevEl = arrowLeft;
  const galleryModal = new Swiper(el, galleryModalOptions);

  const galleryImgs = document.querySelectorAll('.gallery__img');

  galleryImgs.forEach((galleryImg) => {
    galleryImg.addEventListener('click', () => {
      const targetSlide = galleryImg.getAttribute('data-modalslide');
      galleryModal.slideTo(targetSlide - 1, 0);

      galleryPopup.classList.add('is-open');
    });
  });

  const galleryClose = document.querySelector('.gallery-popup__close');
  galleryClose?.addEventListener('click', () => {
    galleryPopup.classList.remove('is-open');
  });
});
